import Vue from 'vue';
import AuthService from './auth-service';
import config from './api-config';

const G_MAP_KEY = 'AIzaSyCv6j0EXuvoIlGCqbVtx2YNroviwmUpCRo';

export default class GeneralService {
  private auth = new AuthService();

  public async getExecutiveDashboard() {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getExecutiveDashboard, {
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getDashboard(id: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getDashboard, {
      params: {
        plantid: id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getPlantsList(id: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getPlantsList, {
      params: {
        customerid: id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getPlantsListAdmin(offset: number, limit: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getAllPlantsAdmin, {
      params: {
        offset: offset,
        limit: limit
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  // public async getPlantAlarms(id: number, filter: string, isInvert: boolean, offset: number, limit: number) {
  //   if (!this.auth.isAuthenticated()) {
  //     this.auth.logout();
  //   }

  //   const response = await Vue.axios.get(config.getPlantAlarms, {
  //     params: {
  //       offset: offset,
  //       limit: limit,
  //       isInvert ? (plantid : id) : (inverter_id: id),

  //     },
  //     headers: { bearer: this.auth.token },
  //   });

  //   const body = response.data;

  //   if (response.status !== 200) {
  //     throw Error(body.message);
  //   }

  //   return body;
  // }

  public async getPlantData(id: number, start: number, end: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getPlantData, {
      params: {
        plantid: id,
        starttime: start,
        endtime: end,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getNetMetered(id: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getNetMetered, {
      params: {
        plant_id: id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getWeatherData(id: number, start: number, end: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getWeatherData, {
      params: {
        plantid: id,
        starttime: start,
        endtime: end,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getDayWiseData(id: number, start: number, end: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getDayWise, {
      params: {
        plantid: id,
        starttime: start,
        endtime: end,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getCustomerList() {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getCustomerList, {
      headers: { authorization: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async GetReportSubscriptionStatus() {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.GetReportSubscriptionStatus, {
      headers: { authorization: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async GetPlantsAndInvertersList() {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.GetPlantsAndInvertersList, {
      headers: { authorization: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getMonthData(id: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getMonthList, {
      params: {
        plantid: id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async Getallalarmsclient(plant_id,inverter_id,statusId) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.get_all_alarms_client, {
      params: {
        plant_id : plant_id,
        filter:statusId,
        offset:0,
        limit:300,
        inverter_id:inverter_id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async getDeviceId(id: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.getDeviceId, {
      params: {
        serial_id: id,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async GetMonthlyReport(plantID) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.get(config.GetGenerateMonthlyReport, {
      params: {
        plant_id: plantID,
      },
      headers: { bearer: this.auth.token },
    });

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }


  public async getInvertorData(deviceId, serialId, action, derating) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    if (derating > 100)
      derating = 100;
    if (derating < 1)
      derating = 1;

    const response = await Vue.axios.post(config.receiveCommand, {
      device_id: deviceId,
      serial_id: serialId,
      action: action,
      value: derating
    },
    );

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async GenerateMonthlyReport(email, planid, start, end,sub,subStart,subEnd,subDate) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.post(config.GenerateMonthlyReport, {
      email: email,
      plantid: planid,
      starttime: start,
      endtime: end,
      subscribe:sub,
      sub_start:subStart,
      sub_end:subEnd,
      sub_date:subDate
    },
    );

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async ChangeReportSubscriptionStatus(is_report_subscribed) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.post(config.ChangeReportSubscriptionStatus, 
      {is_report_subscribed: is_report_subscribed},
      {headers: { 'Authorization': this.auth.token }
    },
    ); 

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }

  public async updateAlarmStatus(id) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.post(config.updatealarmstatus, 
      {serial_id: id},
      {headers: { 'Authorization': this.auth.token }
    },
    ); 

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }


  public async getPVGraph(inverters: Array<string>, start: number, end: number) {
    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
    }

    const response = await Vue.axios.post(config.getPVGraphs, {
      inverters: inverters,
      starttimestamp: start,
      endtimestamp: end,
    }, { headers: { bearer: this.auth.token } }
    );

    const body = response.data;

    if (response.status !== 200) {
      throw Error(body.message);
    }

    return body;
  }
}
